"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { Mail, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";
import { UnderlineInput } from "@/components/UnderlineInput";
import { PasswordInput } from "@/components/PasswordInput";

export function AdminLoginForm() {
  const searchParams = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const err = searchParams.get("error");
    if (err) {
      setError(decodeURIComponent(err));
      window.history.replaceState({}, "", "/admin/login");
    }
  }, [searchParams]);

  return (
    <div className="flex flex-col items-center justify-center p-4">
      <div className="flex w-full max-w-sm flex-col items-center gap-6 rounded-xl border border-white/[0.08] bg-black/50 p-8 shadow-[0_0_60px_rgba(221,30,37,0.08)] backdrop-blur-2xl">
        <Logo variant="icon" size={140} className="drop-shadow-[0_0_30px_rgba(221,30,37,0.25)]" />
        <p className="font-heading text-center text-lg font-bold tracking-tight text-white/60">
          Admin / Facilitator
        </p>

        <form
          action="/api/auth/admin/login"
          method="post"
          onSubmit={() => setError("")}
          className="flex w-full flex-col gap-4"
        >
          <UnderlineInput
            type="email"
            name="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            icon={<Mail className="h-4 w-4" />}
            required
          />
          <PasswordInput
            name="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            icon={<Lock className="h-4 w-4" />}
            required
          />
          {error && <p className="text-sm text-[var(--iris-red)]">{error}</p>}
          <Button type="submit">SIGN IN</Button>
          <Link
            href="/login"
            className="text-center text-sm text-[var(--iris-text-muted)] hover:text-white"
          >
            Participant login
          </Link>
        </form>
      </div>
    </div>
  );
}
